module.exports = __webpack_public_path__ + "static/media/flashlight-on.e49bc9b2.svg";